// @flow weak

import React from 'react';
import bemify, { toModifiers } from 'bemify-js';

import 'app/common/components/PageSection.scss';

import type { Node } from 'react';

import type { KindType } from 'app/common/types';

type PageSectionProps = {
  children?: Node,
  className?: string,
  id?: string,
  kind?: KindType,
};

const PageSection = (props: PageSectionProps) => {
  const bem = bemify('page-section');
  const className = bem(props.className, toModifiers(props.kind));
  return (
    <section className={className} id={props.id}>
      {props.children}
    </section>
  );
};

export default PageSection;
